import React, { useState } from 'react';
import { Upload, FileText, X } from 'lucide-react';

interface PunishmentDocumentTabProps {
  formData: any;
  handleChange: (field: string, value: any) => void;
  readonly?: boolean;
}

export default function PunishmentDocumentTab({
  formData,
  handleChange,
  readonly = false,
}: PunishmentDocumentTabProps) {
  const [errors, setErrors] = useState({});

  const handleFileUpload = (e, field, label) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Max 5MB
    if (file.size > 5 * 1024 * 1024) {
      setErrors(prev => ({ ...prev, [field]: `${label} maksimal 5MB` }));
      e.target.value = '';
      return;
    }

    setErrors(prev => ({ ...prev, [field]: '' }));

    const reader = new FileReader();
    reader.onloadend = () => {
      handleChange(field, reader.result);
    };
    reader.readAsDataURL(file);
  };

  const removeFile = field => {
    handleChange(field, '');
  };

  const FileUploadCard = ({ field, label, accept = '.pdf,.doc,.docx,image/*' }) => (
    <div className="border-2 border-dashed rounded-lg p-4 hover:border-red-400 transition-colors duration-300">
      <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>

      {formData[field] ? (
        <div className="flex items-center justify-between bg-red-50 p-3 rounded-lg">
          <div className="flex items-center gap-2">
            <FileText className="w-5 h-5 text-red-600" />
            <span className="text-sm text-red-700">File terupload</span>
          </div>
          {!readonly && (
            <button
              type="button"
              onClick={() => removeFile(field)}
              className="text-red-500 hover:text-red-700 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      ) : (
        <label className={`block ${readonly ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}>
          <div className="flex flex-col items-center gap-2 py-4 text-gray-500 hover:text-red-600 transition-colors">
            <Upload className="w-8 h-8" />
            <span className="text-sm">Klik untuk upload</span>
            <span className="text-xs text-gray-400">PDF, DOC, atau gambar (max 5MB)</span>
          </div>
          {!readonly && (
            <input
              type="file"
              accept={accept}
              onChange={e => handleFileUpload(e, field, label)}
              className="hidden"
            />
          )}
        </label>
      )}

      {errors[field] && <p className="text-xs text-red-500 mt-2">{errors[field]}</p>}
    </div>
  );

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">Dokumen Pendukung</h3>
        <p className="text-gray-500 text-sm">Upload dokumen terkait hukuman disiplin</p>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <FileUploadCard field="sp_document_url" label="Surat Peringatan (SP)" />
        <FileUploadCard field="bap_document_url" label="Berita Acara Pemeriksaan (BAP)" />
        <FileUploadCard field="evidence_url" label="Bukti Pelanggaran" />
      </div>
    </div>
  );
}
